// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import ReactVisibilitySensor from "react-visibility-sensor";
import * as ResizeObserver2$Showside from "./ResizeObserver2.bs.js";
function InfiniteScrollProximitySensor(Props) {
  var error = Props.error;
  var numLoadedPages = Props.numLoadedPages;
  var numPages = Props.numPages;
  var setNumPages = Props.setNumPages;
  var viewport = Props.viewport;
  var renderChildren = Props.renderChildren;
  var children = Props.children;
  var increaseOffsetForMobileOpt = Props.increaseOffsetForMobile;
  var increaseOffsetForMobile = increaseOffsetForMobileOpt !== undefined ? increaseOffsetForMobileOpt : false;
  var match = React.useState(function () {
    return false;
  });
  var setVisible = match[1];
  var isVisible = match[0];
  var match$1 = React.useState(function () {
    return error;
  });
  var setError = match$1[1];
  var error$1 = match$1[0];
  React.useEffect(function () {
    Curry._1(setError, function (param) {
      return error;
    });
  }, [error]);
  React.useEffect(function () {
    if (isVisible && numLoadedPages >= numPages && error$1 === undefined) {
      Curry._1(setNumPages, numPages + 1 | 0);
    }
  }, [isVisible, numPages, numLoadedPages, error$1]);
  var handleRetry = function (param) {
    Curry._1(setError, function (param) {});
    Curry._1(setNumPages, numPages + 1 | 0);
  };
  var viewportSize = ResizeObserver2$Showside.useWithWindowFallback(viewport);
  var vw = viewportSize.width;
  var vh = viewportSize.height;
  var vw$1 = increaseOffsetForMobile ? vw * 2.5 | 0 : vw;
  var offset_top = -vh | 0;
  var offset_left = -vw$1 | 0;
  var offset_right = -vw$1 | 0;
  var offset_bottom = -vh | 0;
  var offset = {
    top: offset_top,
    left: offset_left,
    right: offset_right,
    bottom: offset_bottom
  };
  var onChange = function (nextIsVisible) {
    Curry._1(setVisible, function (param) {
      return nextIsVisible;
    });
  };
  var renderError = function (param) {
    return Belt_Option.mapWithDefault(error$1, null, function (e) {
      return React.createElement("div", {
        className: CSS$Showside.prefix("flex flex-col space-y-2 justify-center items-center h-full text-tertiary cursor-pointer"),
        onClick: handleRetry
      }, React.createElement("div", {
        className: CSS$Showside.prefix("text-center")
      }, React.createElement(Unicons$Showside.UilSync.make, {})), React.createElement("div", {
        className: CSS$Showside.prefix("text-center leading-normal")
      }, "Failed to fetch more. Retry?"));
    });
  };
  if (children !== undefined) {
    var tmp = {
      partialVisibility: true,
      onChange: onChange,
      children: Caml_option.valFromOption(children),
      offset: offset
    };
    var tmp$1 = Caml_option.nullable_to_opt(viewport.current);
    if (tmp$1 !== undefined) {
      tmp.containment = Caml_option.valFromOption(tmp$1);
    }
    return React.createElement(ReactVisibilitySensor, tmp);
  }
  if (renderChildren === undefined) {
    return null;
  }
  var tmp$2 = {
    partialVisibility: true,
    onChange: onChange,
    children: Curry._1(renderChildren, renderError(undefined)),
    offset: offset
  };
  var tmp$3 = Caml_option.nullable_to_opt(viewport.current);
  if (tmp$3 !== undefined) {
    tmp$2.containment = Caml_option.valFromOption(tmp$3);
  }
  return React.createElement(ReactVisibilitySensor, tmp$2);
}
InfiniteScrollProximitySensor.displayName = "InfiniteScrollProximitySensor";
var make = InfiniteScrollProximitySensor;
export { make };
/* react Not a pure module */